import React, { memo, PropsWithChildren, useContext } from 'react';

import GameController from './controllers/GameController';
import UserController from './controllers/UserController';
import ChatController from './controllers/ChatController';

export interface APIInterface {
  UserController: UserController;
  GameController: GameController;
  ChatController: ChatController;
}

class NetworkAPI implements APIInterface {
  public GameController: GameController;
  public UserController: UserController;
  public ChatController: ChatController;

  constructor() {
    this.GameController = new GameController();
    this.UserController = new UserController();
    this.ChatController = new ChatController();
  }
}

export const APIContext = React.createContext<APIInterface>(null);

export const API = memo(function API({ children }: PropsWithChildren<object>) {
  return <APIContext.Provider value={new NetworkAPI()}>{children}</APIContext.Provider>;
});

export const useAPI = () => useContext(APIContext);
